export const insertStringBetweenText = (
  baseText: string,
  insertedText: string,
  insertCharacterIndex: number,
) => {
  const preInsertedText = baseText.slice(0, insertCharacterIndex)
  const postInsertedText = baseText.slice(insertCharacterIndex, baseText.length)
  return `${preInsertedText}${insertedText}${postInsertedText}`
}
